export default __webpack_public_path__ + "static/media/arrow-back.7d3bb00a.svg";